import React from "react";
import { X, MagnifyingGlass } from "phosphor-react";
import { InputWithHelpersFloatingLabel } from "./Shared";

export function SearchModalInput({
  value,
  setValue,
  setIsSearchActive,
  onFocus,
  validate,
}) {
  return (
    <InputWithHelpersFloatingLabel
      type="text"
      label="Search"
      id="search"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      helpers={[
        <X weight="thin" size={14} onClick={() => setValue("")} />,
        <MagnifyingGlass
          weight="thin"
          size={14}
          onClick={() => setIsSearchActive(true)}
        />,
      ]}
      onFocus={() => onFocus(true)}
      onBlur={() => onFocus(false)}
      autoFocus
      validate={validate}
    />
  );
}
